import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UPN } from '../_models/UPN';
import { CUEServiceBase } from './cue-base.service';
import { CUEServiceListViewBase } from '../_shared/base.management.component';
import { JWTTokenService } from './jwtToken.service';

@Injectable()
export class UPNService extends CUEServiceBase<UPN, UPNListView> {

    constructor(http: HttpClient, jwtTokenService: JWTTokenService) {
        super(http, 'upn', jwtTokenService);
    }

    public getServiceDisplayName(): string {
        return 'UPN';
    }

    /*
    createUPN(model: UPN): Observable<any> {
        this.RemoveFromCache('upnList');
        const endpoint = getUrl('upn');

        if (model.id) {
            return this.http.put(endpoint, model, this.buildOptions());
        } else {
            return this.http.post(endpoint, model, this.buildOptions());
        }
    }

    listUPNs(): Observable<UPN[]> {
        return this.CachedCall('upnList',
            this.http.get<any[]>(getUrl('upn'), this.buildOptions())
                .map(c => {
                    return c.map<UPN>(u => this.map(u));
                }));
    }

    deleteUPN(id: number): Observable<any> {
        this.RemoveFromCache('upnList');
        return this.http.delete(getUrl('upn/' + id), this.buildOptions());
    }

    getUPN(id: number): Observable<UPN> {
        return this.http.get<UPN>(getUrl('upn/' + id), this.buildOptions()).map(u => this.map(u));
    }
    */

    private map(upn: any): UPN {
        const upnObj = JSON.parse(upn.upnJson);

        return <UPN>{
            id: upn.upnId,
            autoswipe: upnObj.autoswipe,
            cooldown: upnObj.cooldown,
            locationTitle: upnObj.locationTitle,
            locationSubtitle: upnObj.locationSubtitle,
            dismissText: upnObj.dismissText,
            firstButtonLat: upnObj.firstButtonLat,
            firstButtonLng: upnObj.firstButtonLng,
            firstButtonText: upnObj.firstButtonText,
            firstButtonType: upnObj.firstButtonType || '',
            firstButtonUrl: upnObj.firstButtonUrl,
            firstImage: upnObj.firstImage,
            lat: +upnObj.lat,
            lng: +upnObj.lng,
            secondButtonLat: upnObj.secondButtonLat,
            secondButtonLng: upnObj.secondButtonLng,
            secondButtonText: upnObj.secondButtonText,
            secondButtonType: upnObj.secondButtonType || '',
            secondButtonUrl: upnObj.secondButtonUrl,
            secondImage: upnObj.secondImage,
            thirdImage: upnObj.thirdImage,
            title: upnObj.title,
            type: upnObj.type,
            iframeUrl: upnObj.iframeUrl
        };
    }

}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface UPNListView extends CUEServiceListViewBase {

}
